<div *ngIf="reportType == 'creditdOutstandingindetails'">
    <div class="container" id="print-section">
        <div class="report-wrapper">
            <table class="report-table">
                <thead>
                    <!-- Header Row 1: Date, Company Name, Report Title -->
                    <tr>
                        <th colspan="2" class="br-bottom br-right bold-text">
                            हिंदुस्थान प्रकाशन संस्था
                        </th>
                        <th colspan="3" class="br-bottom bold-text">
                            जाहिरात रुपये येणे बाकी यादी
                        </th>
                        <th colspan="3" class="br-bottom br-right">
                            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
                        </th>
                    </tr>
                    
                    <!-- Header Row 2: Page Number, Publication, Date Range -->
                    <tr>
                        
                        <th colspan="2" class="br-bottom br-right bold-text">
                            विवेक साप्ताहिक
                        </th>
                        <th colspan="3" class="br-bottom bold-text small-text">
                        </th>
                        <th colspan="3"  class="br-bottom br-right small-text">
                            {{startDate | date: 'dd-MM-yyyy' }} ते {{endDate | date: 'dd-MM-yyyy'}}
                        </th>
                    </tr>
                   
                    <!-- Header Row 3: Column Headers -->
                    <tr>
                        <th class="br-bottom br-right small-text bold-text">देयक क्र</th>
                        <th class="br-bottom br-right small-text bold-text">देयक दिनांक</th>
                        <th class="br-bottom br-right small-text bold-text">जाहिरातदार</th>
                        <th class="br-bottom br-right small-text bold-text">प्रकाशनाचे<br>नाव</th>
                        <th class="br-bottom br-right small-text bold-text">प्रकाशन<br>दिनांक</th>
                        <th class="br-bottom br-right small-text bold-text">एकूण<br>रक्कम</th>
                        <th class="br-bottom br-right small-text bold-text">निव्वळ<br>रक्कम</th>
                        <th class="br-bottom small-text bold-text">येणे बाकी<br>रक्कम</th>
                    </tr>
                </thead>
                
                <tbody *ngFor="let data of creditoutstandingindetails; let i = index">
                    <!-- Office Representative Row -->
                    <tr>
                        <td colspan="2" class="off_rep_name br-bottom br-right small-text">
                            कार्यालानियाय प्रतिनिधी
                        </td>
                        <td colspan="7" class="off_rep_name br-bottom small-text">
                            {{data.off_rep_name}} {{data.office_rep_mob}}
                        </td>
                    </tr>

                    <!-- Representative Data -->
                    <ng-container *ngFor="let data1 of data.rep_data; let j = index">
                        <!-- Representative Row -->
                        <tr>
                            <td colspan="2" class="rep_name br-bottom br-right small-text">
                                प्रतिनिधी
                            </td>
                            <td colspan="6" class="rep_name br-bottom small-text">
                                {{data1.rep_name}} {{data1.rep_mob_no}}
                            </td>
                        </tr>

                        <!-- Advertisement Data Rows -->
                        <tr *ngFor="let data2 of data1.advt_data; let k = index">
                            <td class="br-bottom br-right small-text">
                                {{data2.advt_invoice_no}}
                            </td>
                            <td class="br-bottom br-right small-text">
                                {{data2.advt_invoice_date}}
                            </td>
                            <td  class="br-bottom br-right small-text">
                                {{data2.advt_name | slice : 0:30}}
                            </td>
                            <td class="br-bottom br-right small-text">
                                {{data2.issue_name | slice : 0:20}}
                            </td>
                            <td class="br-bottom br-right small-text">
                                {{data2.issue_date}}
                            </td>
                            <td class="br-bottom br-right text-end small-text">
                                {{(data2.net_amt * 1).toFixed(2)}}
                            </td>
                            <td class="br-bottom br-right text-end small-text">
                                {{(data2.rcv_amt * 1).toFixed(2)}}
                            </td>
                            <td class="br-bottom text-end small-text">
                                {{(data2.unpaid_amt * 1).toFixed(2)}}
                            </td>
                        </tr>

                        <!-- Representative Total Row -->
                        <tr class="total-row">
                            <td colspan="5" class="br-bottom br-right small-text bold-text" style="text-align: right;">
                                प्रतिनिधी एकूण :
                            </td>
                            <td class="br-bottom br-right text-end small-text bold-text">
                                {{(data1.advt_amt_total * 1).toFixed(2)}}
                            </td>
                            <td class="br-bottom br-right text-end small-text bold-text">
                                {{(data1.net_amt_total * 1).toFixed(2)}}
                            </td>
                            <td class="br-bottom text-end small-text bold-text">
                                {{(data1.unpaid_amt_total * 1).toFixed(2)}}
                            </td>
                        </tr>
                    </ng-container>

                    <!-- Office Representative Total Row -->
                    <tr class="total-row" style="background-color: #e8f5e9;">
                        <td colspan="5" class="br-bottom br-right small-text bold-text" style="text-align: right;">
                            कार्यालय प्रतिनिधी एकूण :
                        </td>
                        <td class="br-bottom br-right text-end small-text bold-text">
                            {{(getOfficeRepTotal(data.rep_data, 'advt_amt_total') * 1).toFixed(2)}}
                        </td>
                        <td class="br-bottom br-right text-end small-text bold-text">
                            {{(getOfficeRepTotal(data.rep_data, 'net_amt_total') * 1).toFixed(2)}}
                        </td>
                        <td class="br-bottom text-end small-text bold-text">
                            {{(getOfficeRepTotal(data.rep_data, 'unpaid_amt_total') * 1).toFixed(2)}}
                        </td>
                    </tr>
                </tbody>

                <!-- Grand Total Row -->
                <tfoot>
                    <tr class="total-row" style="background-color: #fff9c4;">
                        <td colspan="5" class="br-bottom br-right small-text bold-text" style="text-align: right; font-size: 15px;">
                            सर्व एकूण :
                        </td>
                        <td class="br-bottom br-right text-end small-text bold-text" style="font-size: 15px;">
                            {{(creditonlyOutStandingIDTotal * 1).toFixed(2)}}
                        </td>
                        <td class="br-bottom br-right text-end small-text bold-text" style="font-size: 15px;">
                            {{(creditonlyOutStandingIDNetAmtTotal * 1).toFixed(2)}}
                        </td>
                        <td class="br-bottom text-end small-text bold-text" style="font-size: 15px;">
                            {{(creditonlyOutStandingIDUnPaidTotal * 1).toFixed(2)}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="actions">
        <button class="noPrint btn-export" (click)="exportExcel('Contract_InDetails_Report')" 
                mat-raised-button color="primary">
            Export
        </button>
        
        <button id="print-button" class="noPrint btn-print" style="display: none;" 
                mat-raised-button color="primary" printSectionId="print-section" 
                [useExistingCss]="true" ngxPrint>
            Print (Hidden)
        </button>

        <button (click)="print()" class="noPrint btn-print" mat-raised-button color="primary">
            Print
        </button>
        
        <button class="noPrint btn-close" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>